exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Card__card {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 64px;\n  outline: none;\n}\n\n.DS__Card__card-icon {\n  display: flex;\n  align-items: center;\n  margin-right: 25px;\n}\n\n.DS__Card__card-expiration {\n  margin-left: auto;\n}\n\n.DS__Card__card-cvc {\n  width: 80px;\n  margin-left: 24px;\n}\n\n.DS__Card__disable-pointer-events {\n  pointer-events: none;\n  cursor: default;\n  -webkit-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.DS__Card__radio {\n  margin-right: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"card": "DS__Card__card",
	"card-icon": "DS__Card__card-icon",
	"card-expiration": "DS__Card__card-expiration",
	"card-cvc": "DS__Card__card-cvc",
	"disable-pointer-events": "DS__Card__disable-pointer-events",
	"radio": "DS__Card__radio"
};